import { useSelector } from "react-redux";

import { IStore } from "../interfaces/IStore";
import { IUIState } from "../interfaces/IUI";

export const useUI = (): IUIState => useSelector((state: IStore) => state.ui);
